import { resolveState } from "../changes";
import { BasicStyle, CropStyle } from "../types";
import { CropVarietyRow } from "./CropVarietyRow";

export interface CropVarietyRowsProps {
    cropStyle: CropStyle;
    setCropStyle: React.Dispatch<React.SetStateAction<CropStyle>>;
}

export const CropVarietyRows = ({ setCropStyle, cropStyle }: CropVarietyRowsProps): JSX.Element => {
    const updateCropVariety = React.useCallback(
        (id: number, action: React.SetStateAction<BasicStyle>) => {
            setCropStyle((prev) => ({
                ...prev,
                varieties: prev.varieties.map((v) => {
                    if (v.varietyId === id) {
                        return { ...v, ...resolveState(v, action) };
                    } else {
                        return v;
                    }
                }),
            }));
        },
        [setCropStyle]
    );
    return (
        <>
            {cropStyle.varieties.map((variety) => (
                <CropVarietyRow
                    key={variety.varietyId}
                    crop={cropStyle}
                    variety={variety}
                    onChange={(value) => updateCropVariety(variety.varietyId, value)}
                />
            ))}
        </>
    );
};
